import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";

const Shop = () => {
    const [rooms,setRooms] = useState([]);
    useEffect (() =>{
        const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
        const UrlRooms = process.env.REACT_APP_API_ROOMS;
        const saved = localStorage.getItem("rooms");
        if (saved) setRooms(JSON.parse(saved));
        else {
            axios.get(`${apiBaseUrl}${UrlRooms}`)
                .then((response) => {
                    setRooms(response.data);
                    localStorage.setItem("rooms", JSON.stringify(response.data));
                })
                .catch(error => console.error("Fetch Error", error));
        }
    },[]);

    return (
        <main className="overflow-x-hidden">
            <section className="blog-banner-area" id="blog">
                <div className="container h-100">
                    <div className="blog-banner">
                        <div className="text-center">
                            <h1>Buy Your Goods</h1>
                            <nav aria-label="breadcrumb" className="banner-breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/">Home</Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">Super Shop</li>
                                </ol>
                            </nav>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-2">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 col-xl-12 mb-5">
                            <div className="card card-explore">
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="card-explore__img">
                                            <img className="card-img" src="shops/shop-1.png" alt="img not found"/>
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="card-body">
                                            <h4 className="card-explore__title">LuLu Hypermarket</h4>
                                            <p>A leading retail chain offering a wide range of products, including
                                                groceries, electronics, and household items.</p>
                                            <p>
                                                <div className="resturent__content-contact mt-20 d-flex">
                                                    <div className="">
                                                        <svg width="14" height="11" viewBox="0 0 14 11" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M12.6875 0.5C13.3984 0.5 14 1.10156 14 1.8125C14 2.25 13.7812 2.63281 13.4531 2.87891L7.51953 7.33594C7.19141 7.58203 6.78125 7.58203 6.45312 7.33594L0.519531 2.87891C0.191406 2.63281 0 2.25 0 1.8125C0 1.10156 0.574219 0.5 1.3125 0.5H12.6875ZM5.93359 8.04688C6.5625 8.51172 7.41016 8.51172 8.03906 8.04688L14 3.5625V9.25C14 10.2344 13.207 11 12.25 11H1.75C0.765625 11 0 10.2344 0 9.25V3.5625L5.93359 8.04688Z"
                                                                fill="#AF8C3E"></path>
                                                        </svg>
                                                    </div>
                                                    <a href="mailto:info@sa.lulumea.com"
                                                       className="title mx-2">info@sa.lulumea.com</a>
                                                </div>
                                                <div className="resturent__content-contact mt-20  d-flex">
                                                    <div className="icon">
                                                        <svg width="17" height="18" viewBox="0 0 17 18" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M15.9688 13.0938L15.2188 16.25C15.125 16.7188 14.75 17.0312 14.2812 17.0312C6.40625 17 0 10.5938 0 2.71875C0 2.25 0.28125 1.875 0.75 1.78125L3.90625 1.03125C4.34375 0.9375 4.8125 1.1875 5 1.59375L6.46875 5C6.625 5.40625 6.53125 5.875 6.1875 6.125L4.5 7.5C5.5625 9.65625 7.3125 11.4062 9.5 12.4688L10.875 10.7812C11.125 10.4688 11.5938 10.3438 12 10.5L15.4062 11.9688C15.8125 12.1875 16.0625 12.6562 15.9688 13.0938Z"
                                                                fill="#AF8C3E"></path>
                                                        </svg>
                                                    </div>
                                                    <a href="tel:8001000330" className="title mx-2">8001000330</a>
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-xl-12 mb-5">
                            <div className="card card-explore">
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="card-body">
                                            <h4 className="card-explore__title">Panda Retail Company</h4>
                                            <p>One of the largest supermarket chains in Saudi Arabia, providing diverse
                                                products at competitive prices.</p>
                                            <p>
                                                <div className="resturent__content-contact mt-20 d-flex">
                                                    <div className="">
                                                        <svg width="14" height="11" viewBox="0 0 14 11" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M12.6875 0.5C13.3984 0.5 14 1.10156 14 1.8125C14 2.25 13.7812 2.63281 13.4531 2.87891L7.51953 7.33594C7.19141 7.58203 6.78125 7.58203 6.45312 7.33594L0.519531 2.87891C0.191406 2.63281 0 2.25 0 1.8125C0 1.10156 0.574219 0.5 1.3125 0.5H12.6875ZM5.93359 8.04688C6.5625 8.51172 7.41016 8.51172 8.03906 8.04688L14 3.5625V9.25C14 10.2344 13.207 11 12.25 11H1.75C0.765625 11 0 10.2344 0 9.25V3.5625L5.93359 8.04688Z"
                                                                fill="#AF8C3E"></path>
                                                        </svg>
                                                    </div>
                                                    <a href="customer.service@panda.com.sa"
                                                       className="title mx-2">customer.service@panda.com.sa</a>
                                                </div>
                                                <div className="resturent__content-contact mt-20  d-flex">
                                                    <div className="icon">
                                                        <svg width="17" height="18" viewBox="0 0 17 18" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M15.9688 13.0938L15.2188 16.25C15.125 16.7188 14.75 17.0312 14.2812 17.0312C6.40625 17 0 10.5938 0 2.71875C0 2.25 0.28125 1.875 0.75 1.78125L3.90625 1.03125C4.34375 0.9375 4.8125 1.1875 5 1.59375L6.46875 5C6.625 5.40625 6.53125 5.875 6.1875 6.125L4.5 7.5C5.5625 9.65625 7.3125 11.4062 9.5 12.4688L10.875 10.7812C11.125 10.4688 11.5938 10.3438 12 10.5L15.4062 11.9688C15.8125 12.1875 16.0625 12.6562 15.9688 13.0938Z"
                                                                fill="#AF8C3E"></path>
                                                        </svg>
                                                    </div>
                                                    <a href="tel:+966 9200 27779" className="title mx-2">+966 9200
                                                        27779</a>
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="card-explore__img">
                                            <img className="card-img" src="shops//shop-2.png" alt="img not found"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-xl-12 mb-5">
                            <div className="card card-explore">
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="card-explore__img">
                                            <img className="card-img" src="shops//shop-3.png" alt="img not found"/>
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="card-body">
                                            <h4 className="card-explore__title">Abdullah Al Othaim Markets</h4>
                                            <p>Provides a wide range of food and non-food products, focusing on
                                                affordability and quality.</p>
                                            <p>
                                                <div className="resturent__content-contact mt-20 d-flex">
                                                    <div className="">
                                                        <svg width="14" height="11" viewBox="0 0 14 11" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M12.6875 0.5C13.3984 0.5 14 1.10156 14 1.8125C14 2.25 13.7812 2.63281 13.4531 2.87891L7.51953 7.33594C7.19141 7.58203 6.78125 7.58203 6.45312 7.33594L0.519531 2.87891C0.191406 2.63281 0 2.25 0 1.8125C0 1.10156 0.574219 0.5 1.3125 0.5H12.6875ZM5.93359 8.04688C6.5625 8.51172 7.41016 8.51172 8.03906 8.04688L14 3.5625V9.25C14 10.2344 13.207 11 12.25 11H1.75C0.765625 11 0 10.2344 0 9.25V3.5625L5.93359 8.04688Z"
                                                                fill="#AF8C3E"></path>
                                                        </svg>
                                                    </div>
                                                    <a href="mailto:info@othaimmarkets.com"
                                                       className="title mx-2">info@othaimmarkets.com</a>
                                                </div>
                                                <div className="resturent__content-contact mt-20  d-flex">
                                                    <div className="icon">
                                                        <svg width="17" height="18" viewBox="0 0 17 18" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M15.9688 13.0938L15.2188 16.25C15.125 16.7188 14.75 17.0312 14.2812 17.0312C6.40625 17 0 10.5938 0 2.71875C0 2.25 0.28125 1.875 0.75 1.78125L3.90625 1.03125C4.34375 0.9375 4.8125 1.1875 5 1.59375L6.46875 5C6.625 5.40625 6.53125 5.875 6.1875 6.125L4.5 7.5C5.5625 9.65625 7.3125 11.4062 9.5 12.4688L10.875 10.7812C11.125 10.4688 11.5938 10.3438 12 10.5L15.4062 11.9688C15.8125 12.1875 16.0625 12.6562 15.9688 13.0938Z"
                                                                fill="#AF8C3E"></path>
                                                        </svg>
                                                    </div>
                                                    <a href="tel:+966 11 254 6666" className="title mx-2">+966 11 254
                                                        6666</a>
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-12 col-xl-12 mb-5">
                            <div className="card card-explore">
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="card-body">
                                            <h4 className="card-explore__title">Tamimi Markets</h4>
                                            <p>A popular chain known for its fresh produce and international product
                                                range.</p>
                                            <p>
                                                <div className="resturent__content-contact mt-20 d-flex">
                                                    <div className="">
                                                        <svg width="14" height="11" viewBox="0 0 14 11" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M12.6875 0.5C13.3984 0.5 14 1.10156 14 1.8125C14 2.25 13.7812 2.63281 13.4531 2.87891L7.51953 7.33594C7.19141 7.58203 6.78125 7.58203 6.45312 7.33594L0.519531 2.87891C0.191406 2.63281 0 2.25 0 1.8125C0 1.10156 0.574219 0.5 1.3125 0.5H12.6875ZM5.93359 8.04688C6.5625 8.51172 7.41016 8.51172 8.03906 8.04688L14 3.5625V9.25C14 10.2344 13.207 11 12.25 11H1.75C0.765625 11 0 10.2344 0 9.25V3.5625L5.93359 8.04688Z"
                                                                fill="#AF8C3E"></path>
                                                        </svg>
                                                    </div>
                                                    <a href="mailto:info@tamimimarkets.com"
                                                       className="title mx-2">info@tamimimarkets.com</a>
                                                </div>
                                                <div className="resturent__content-contact mt-20  d-flex">
                                                    <div className="icon">
                                                        <svg width="17" height="18" viewBox="0 0 17 18" fill="none"
                                                             xmlns="http://www.w3.org/2000/svg">
                                                            <path
                                                                d="M15.9688 13.0938L15.2188 16.25C15.125 16.7188 14.75 17.0312 14.2812 17.0312C6.40625 17 0 10.5938 0 2.71875C0 2.25 0.28125 1.875 0.75 1.78125L3.90625 1.03125C4.34375 0.9375 4.8125 1.1875 5 1.59375L6.46875 5C6.625 5.40625 6.53125 5.875 6.1875 6.125L4.5 7.5C5.5625 9.65625 7.3125 11.4062 9.5 12.4688L10.875 10.7812C11.125 10.4688 11.5938 10.3438 12 10.5L15.4062 11.9688C15.8125 12.1875 16.0625 12.6562 15.9688 13.0938Z"
                                                                fill="#AF8C3E"></path>
                                                        </svg>
                                                    </div>
                                                    <a href="tel:+966 13 808 1000" className="title mx-2">+966 13 808
                                                        1000</a>
                                                </div>
                                            </p>
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="card-explore__img">
                                            <img className="card-img" src="shops//shop-4.png" alt="img not found"/>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className="py-2">
                <div className="container">
                    <div className="row">
                        <h1 className="text-center fw-bold text-danger">Attension Please</h1>
                        <hr/>
                        <p className="" align="justify">
                            If you're looking for the best shopping experience, visit our super shop website or mobile
                            app for easy and convenient shopping. Explore a wide range of high-quality products at great
                            prices. For a more personalized experience, visit our super shop outlets, where premium
                            products and excellent customer service await you. Whether online or in-store, we ensure
                            top-notch quality, unbeatable deals, and a seamless shopping journey. Shop with us today and
                            enjoy the ultimate convenience and satisfaction in every purchase!
                        </p>
                    </div>
                </div>
            </section>
        </main>
    );
};

export default Shop;